import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { IAccessRequest, IAccessRequests } from '@interfaces/guestClient';

export interface IAccessRequestsState extends IAccessRequests {}

export const INITIAL_STATE: IAccessRequestsState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class GuestClientsStore {
	private _guestClientsState = new BehaviorSubject<IAccessRequestsState>(
		INITIAL_STATE
	);
	readonly guestClientsState$ = this._guestClientsState.asObservable();

	constructor() {}

	updateGuestClients(Guestclients: IAccessRequestsState) {
		const state = this._guestClientsState.value;

		const data = {
			...state,
			...Guestclients,
		};

		this._guestClientsState.next(data);

		return this._guestClientsState.asObservable();
	}

	updateGuestClient(accessRequest: IAccessRequest) {
		const state = this._guestClientsState.value;

		const requestIndex = state.result.findIndex(
			({ id }) => id === accessRequest.id
		);

		state.result.splice(requestIndex, 1);

		const data = state;

		this._guestClientsState.next(data);

		return this._guestClientsState.asObservable();
	}
}
